import { FC } from 'react';

export const VideoHero: FC = () => {
  const videoUrl = "https://twufxrbqgkgynmalmowy.supabase.co/storage/v1/object/public/videos/video-noticia-educacion-financiera.mp4?t=2024-12-18T17%3A45%3A32.192Z";

  return (
    <div className="relative w-full aspect-video max-w-5xl mx-auto rounded-xl overflow-hidden shadow-xl mb-8">
      <div className="w-full h-full bg-gray-200">
        <video
          className="w-full h-full object-cover"
          controls
          src={videoUrl}
        >
          Tu navegador no soporta la reproducción de videos.
        </video>
      </div>
    </div>
  );
};